import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { sortWith4fnm6b3vw03s as sortWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var EntryClass;
function Entry() {
  if (EntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.key_1 = key;
        this.value_1 = value;
      }
      component2_7eebsb_k$() {
        return this.value_1;
      }
      toString() {
        return 'Entry(key=' + toString(this.key_1) + ', value=' + toString_0(this.value_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.key_1);
        result = imul(result, 31) + (this.value_1 == null ? 0 : hashCode(this.value_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Entry()))
          return false;
        if (!equals(this.key_1, other.key_1))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Entry');
    EntryClass = $;
  }
  return EntryClass;
}
function sublist($this, key) {
  if ($this.list_1.isEmpty_y1axqb_k$())
    return null;
  var firstIdx = indexOfFirst($this, key);
  if (firstIdx === $this.list_1.get_size_woubt6_k$() || !equals($this.list_1.get_c1px32_k$(firstIdx).key_1, key))
    return null;
  var oneAfter = insertIndexAfterLast($this, key);
  return $this.list_1.subList_xle3r2_k$(firstIdx, oneAfter);
}
function indexOfFirst($this, key) {
  // Inline function 'com.lightningkite.kiteui.utils.OrderedKeyedList.optimizedBinarySearchFirstIndexWhereFalse' call
  var left = 0;
  var right = $this.list_1.get_size_woubt6_k$();
  while (left < right) {
    var mid = left + ((right - left | 0) / 2 | 0) | 0;
    var it = $this.list_1.get_c1px32_k$(mid).key_1;
    if (compareTo(it, key) < 0) {
      left = mid + 1 | 0;
    } else {
      right = mid;
    }
  }
  return left;
}
function insertIndexAfterLast($this, key) {
  // Inline function 'com.lightningkite.kiteui.utils.OrderedKeyedList.optimizedBinarySearchFirstIndexWhereFalse' call
  var left = 0;
  var right = $this.list_1.get_size_woubt6_k$();
  while (left < right) {
    var mid = left + ((right - left | 0) / 2 | 0) | 0;
    var it = $this.list_1.get_c1px32_k$(mid).key_1;
    if (compareTo(it, key) <= 0) {
      left = mid + 1 | 0;
    } else {
      right = mid;
    }
  }
  return left;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function OrderedKeyedList$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.key_1;
  var tmp$ret$2 = b.key_1;
  return compareValues(tmp, tmp$ret$2);
}
var OrderedKeyedListClass;
function OrderedKeyedList() {
  if (OrderedKeyedListClass === VOID) {
    class $ {
      constructor(list) {
        return new.target.new_com_lightningkite_kiteui_utils_OrderedKeyedList_pzp04i_k$(list);
      }
      static new_com_lightningkite_kiteui_utils_OrderedKeyedList_pzp04i_k$(list) {
        var $this = createThis(this);
        $this.list_1 = list;
        // Inline function 'kotlin.collections.sortBy' call
        var this_0 = $this.list_1;
        if (this_0.get_size_woubt6_k$() > 1) {
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp = OrderedKeyedList$lambda;
          var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp);
          sortWith(this_0, tmp$ret$1);
        }
        return $this;
      }
      static new_com_lightningkite_kiteui_utils_OrderedKeyedList_k7i2c9_k$() {
        return this.new_com_lightningkite_kiteui_utils_OrderedKeyedList_pzp04i_k$(ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$());
      }
      add_s9j6db_k$(key, value) {
        if (this.list_1.isEmpty_y1axqb_k$())
          this.list_1.add_utx5q5_k$(new (Entry())(key, value));
        else {
          this.list_1.add_dl6gt3_k$(insertIndexAfterLast(this, key), new (Entry())(key, value));
        }
      }
      get_mqs22f_k$(key) {
        var tmp0_elvis_lhs = sublist(this, key);
        return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
      }
      remove_v7qput_k$(key) {
        var tmp0_elvis_lhs = sublist(this, key);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return 0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var list = tmp;
        var c = list.get_size_woubt6_k$();
        list.clear_j9egeb_k$();
        return c;
      }
      set_y4lt5s_k$(key, value) {
        var list = sublist(this, key);
        if (list == null) {
          this.add_s9j6db_k$(key, value);
          return Unit_instance;
        }
        list.clear_j9egeb_k$();
        list.add_utx5q5_k$(new (Entry())(key, value));
      }
      isEmpty_y1axqb_k$() {
        return this.list_1.isEmpty_y1axqb_k$();
      }
      contains_n2zbuf_k$(element) {
        return this.list_1.contains_aljjnj_k$(element);
      }
      contains_aljjnj_k$(element) {
        if (!(element instanceof Entry()))
          return false;
        return this.contains_n2zbuf_k$(element instanceof Entry() ? element : THROW_CCE());
      }
      iterator_jk1svi_k$() {
        return this.list_1.iterator_jk1svi_k$();
      }
      get_c1px32_k$(index) {
        return this.list_1.get_c1px32_k$(index);
      }
      indexOf_bz1u1t_k$(element) {
        return this.list_1.indexOf_si1fv9_k$(element);
      }
      indexOf_si1fv9_k$(element) {
        if (!(element instanceof Entry()))
          return -1;
        return this.indexOf_bz1u1t_k$(element instanceof Entry() ? element : THROW_CCE());
      }
      listIterator_70e65o_k$(index) {
        return this.list_1.listIterator_70e65o_k$(index);
      }
      subList_xle3r2_k$(fromIndex, toIndex) {
        return this.list_1.subList_xle3r2_k$(fromIndex, toIndex);
      }
      get_size_woubt6_k$() {
        return this.list_1.get_size_woubt6_k$();
      }
    }
    initMetadataForClass($, 'OrderedKeyedList', $.new_com_lightningkite_kiteui_utils_OrderedKeyedList_k7i2c9_k$, VOID, [KtList()]);
    OrderedKeyedListClass = $;
  }
  return OrderedKeyedListClass;
}
//region block: exports
export {
  Entry as Entry3ibt1cjje8fz9,
  OrderedKeyedList as OrderedKeyedListh74dkke7tuy6,
};
//endregion

//# sourceMappingURL=OrderedKeyedList.mjs.map
